import { Field as TextField } from './text'

export const Field = (props) => <TextField {...props} type='password' />
